// extracted by mini-css-extract-plugin
export default {"list":"Notification_list__tKNvr"};